<template>
	<div class="row">
		<div class="col-md-12">
			<div class="form-group">
				<label>Resource Type</label>
				<multiselect
					name="link_type"
					:options="optionsForLinkType.map(x => x.id)"
					label="name"
					v-model="linkType.value"
					:allow-empty="false"
					:disabled="isFile"
				>
					<template slot="singleLabel" slot-scope="props">
						<img class="link-type-icon" :src="require(`@/csmworkflow/img/${getOptionObject(props.option).icon}`)" alt="icon">
						<span v-if="!isFile" class="link-type-title">{{ getOptionObject(props.option).name }}</span>
						<span v-if="isFile">{{linkLabel.value}}</span>
					</template>
					<template slot="option" slot-scope="props">
						<img class="link-type-icon" :src="require(`@/csmworkflow/img/${getOptionObject(props.option).icon}`)" alt="icon">
						<span class="link-type-title">{{ getOptionObject(props.option).name }}</span>
					</template>
				</multiselect>
			</div>
		</div>
		<div class="col-md-12" v-show="!isFile">
			<div class="form-group">
				<label>URL</label>
				<div class="input-group">
					<input type="text" v-model="linkUrl.value" class="form-control"  v-on:keyup.enter="saveFn" ref="focusThis"/>
					<div class="input-group-append">
						<button @click="copyUrl" id="copy-url-btn" class="btn btn-text btn-copy" type="button" data-dismiss="modal"><i :class="copyIcon"></i></button>
						<b-tooltip target="copy-url-btn" triggers="hover" noninteractive>{{copyTooltipText}}</b-tooltip>
					</div>
				</div>
			</div>
		</div>
		<div class="col-md-12" v-show="!isFile">
			<div class="form-group">
				<label>Label</label>
				<input type="text" v-model="linkLabel.value" class="form-control"  v-on:keyup.enter="saveFn" />
			</div>
		</div>
		<div class="col-md-12">
			<div class="form-group">
				<label>Notes</label>
				<textarea class="form-control" v-model="linkNotes.value"></textarea>
			</div>
		</div>

		<div class="row col-md-12">
		<div class="col">
			<button class="btn btn-primary" type="button" @click="saveFn" data-dismiss="modal">Update</button>
		</div>
		<div class="col text-right">
			<button class="btn btn-text" type="button" @click="removeLink" data-dismiss="modal">Delete</button>
		</div>
		</div>
		<b-modal v-model="showRemoveLink" type="warn" title="Confirm Deletion" @ok="removeFn" ok-title="Yes, Delete">
			<p>Are you sure you want to delete this resource/link?</p>
		</b-modal>
	</div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
	props: {
		linkUrl:Object,
		linkLabel:Object,
		linkNotes:Object,
		linkType:Object,
		isFile:Boolean
	},
	data() {
		return {
			filteredStates: [],
      		showRemoveLink: false,
			copySuccessTimeout: null,
			copyIcon: 'far fa-copy',
			copyTooltipText: 'Copy URL',
		};
	},
	computed: {
		...mapGetters(["allCustomFields"]),

		optionsForLinkType() {
			const linkTypeField = this.allCustomFields.find(x => x.id == 37);
			const linkTypeArray = JSON.parse(linkTypeField.value_set);
			const fileTypeArray = linkTypeArray.filter(item => item.slug == 'file');

			if (typeof fileTypeArray != "undefined") {
				if (typeof fileTypeArray[0] == "undefined") {
					const filteredArray = linkTypeArray.filter(item => item.slug !== 'file');
					return filteredArray;
				}
			} else {
				const filteredArray = linkTypeArray.filter(item => item.slug !== 'file');
				return filteredArray;
			}
			return linkTypeArray;
		},
	},
	methods: {
		focusMyElement() {
			if (this.$refs.focusThis) {
				this.$refs.focusThis.focus();
			}
		},
		saveFn() {
			let that = this;
			this.$store
				.dispatch("updateProjectLinkUrl", {linkUrl:this.linkUrl,linkLabel:this.linkLabel,linkNotes:this.linkNotes,linkType:this.linkType})
				.then(() => {
					that.$bvModal.hide('editProjectLinkModal')
				});
		},
		removeLink() {
			this.showRemoveLink = true;
		},
		removeFn() {
			let that = this;
			if (this.linkUrl.id) {
				this.$store
					.dispatch("removeProjectLinkUrl", {linkUrl: this.linkUrl.pfv_id})
					.then(() => {
						that.$bvModal.hide('editProjectLinkModal')
					});


			} else {
				that.$bvModal.hide('editProjectLinkModal')
			}
		},
		getOptionObject(id) {
			return this.optionsForLinkType.find(x => x.id == id);
		},

		async copyUrl() {
			clearTimeout(this.copySuccessTimeout);
			const navPer = await navigator.permissions.query({name: "clipboard-write"});
			if (navPer.state == "granted" || navPer.state == "prompt") {
				try {
					await navigator.clipboard.writeText(this.linkUrl.value);
				} catch {
					console.error("clipboard API error. Cannot copy to clipboard.");
					this.legacyCopyMethod();
				}
			} else {
				this.legacyCopyMethod();
			}


			this.copyIcon = "fas fa-check";
			this.copyTooltipText = "Copied!";
			this.copySuccessTimeout = setTimeout(() => {
				this.copyIcon = "far fa-copy";
				this.copyTooltipText = "Copy URL";
			}, 2000);
		},
		legacyCopyMethod() {
			this.$refs.focusThis.select();
			document.execCommand("copy");
			this.$refs.focusThis.blur();
		},
	},
	created() {
	}
};
</script>

<style>
</style>